var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-container-header"},[_c('i',{staticClass:"far fa-chevron-left",on:{"click":_vm.backHomePageHandler}}),_c('h1',[_vm._v(_vm._s(_vm.getOrderNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }